import _ from 'lodash'
import { FC, useEffect, useState } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { Placement } from 'react-bootstrap/esm/types'

export interface IPopover {
  id: any
  body?: any
  className?: any
  header?: any
  headerClassName?: any
  bodyClassName?: any
  icon?: any
  placement?: Placement
}

const PopOver: FC<IPopover> = (props: IPopover) => {
  const initialIconElement = <i className={`ml-2 text-secondary fas fa-info-circle`}></i>;
  const { id, className, header, headerClassName = 'bg-light text-center', body, bodyClassName, icon, placement = 'auto' } = props
  const [iconElement, setIconElement] = useState<any>(initialIconElement)
  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      if (!_.isUndefined(icon)) {
        if (_.isString(icon)) setIconElement(<i className={`ml-2 text-secondary ${icon}`}></i>)
        else setIconElement(icon)
      }
    }
    return () => {
      isMounted = false
      setIconElement(initialIconElement)
    }
  }, [icon])

  const popover = (id: string | number) => (
    <Popover id={'popover-' + id} className={className}>
      {header && (
        <Popover.Header as="h3" className={headerClassName}>
          {header}
        </Popover.Header>
      )}
      <Popover.Body className={bodyClassName}>{body}</Popover.Body>
    </Popover>
  )

  return (
    <>
      {iconElement && (
        <OverlayTrigger trigger={['hover', 'focus']} placement={placement} overlay={popover(id)} children={iconElement}></OverlayTrigger>
      )}
    </>
  )
}

export default PopOver
